import React from 'react';
import { get } from 'lodash-es';
import PropTypes from 'prop-types';
/* Models */
import { DealerInfoEntities } from 'client/data/models/dealer-info';
import { InventoryEntities } from 'client/data/models/inventory';
/* Utils */
import { toDisplayString } from 'site-modules/shared/utils/phone-format';
import { getShortcutWorkingHours } from 'site-modules/financing/utils/short-working-hours-mapping';

export function IneligibleVinScreenError({ vehicle = {}, dealerInfo = {}, isMobile = false }) {
  const dealerName = get(vehicle, 'dealerInfo.name', get(dealerInfo, 'name', ''));
  const phone = get(
    vehicle,
    'dealerInfo.phoneNumbers.trackable',
    get(
      vehicle,
      'dealerInfo.phoneNumbers.ppTrackable',
      get(vehicle, 'dealerInfo.phoneNumbers.basicTrackable', get(vehicle, 'dealerInfo.phoneNumbers.basic', {}))
    )
  );
  const formattedPhone = toDisplayString(phone);
  const workHours = get(vehicle, 'dealerInfo.workHours', get(dealerInfo, 'workHours', {}));
  const dealerWorkHours = getShortcutWorkingHours(workHours, true);
  const copy = isMobile
    ? "If you're still interested in this specific vehicle, contact the dealer to discuss your options."
    : 'Still interested in this specific vehicle?Contact the dealer directly to discuss your options.';

  return (
    <div data-tracking-parent="ineligible_vin">
      <h3 className="mb-0_75 size-24">It looks like this particular listing is not eligible for prequalification.</h3>
      <p>
        This could happen if the vehicle is too old, has too many miles on it, or is missing key information, such as a
        list price.
      </p>
      <div className="info-wrapper ineligible-vin p-1 bg-gray-extra-light my-2 text-center mx-auto">
        <div className="size-20 text-start">{copy}</div>
        <hr className="mt-1 mb-1_5" />
        <div className="fw-bold mb-0_5">Call {dealerName}</div>
        <div className="fw-bold mb-0_75 ">
          <i className="size-16 icon-phone2 me-0_25 text-primary-darker" aria-hidden />
          <a className="size-20 text-primary-darker" href={`tel:${formattedPhone}`}>
            {formattedPhone}
          </a>
        </div>
        <ul className="list-unstyled mb-0_5" aria-label="Work schedule">
          {dealerWorkHours.map(dealerWorkHour => (
            <li key={dealerWorkHour} className="size-14">
              {dealerWorkHour}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
IneligibleVinScreenError.propTypes = {
  vehicle: InventoryEntities.InventoryVin,
  dealerInfo: DealerInfoEntities.DealerInfo,
  isMobile: PropTypes.bool,
};
